import * as React from 'react';
import styled from 'styled-components';

import { useSpring, animated } from 'react-spring';
import { Logo } from './logo';
import { DesktopMenuElements } from './desktop-menu-elements';
import { ModalMenu } from './modal-menu';
import { IMenuProps } from './menytypes';
import { useLocation, useParams } from 'react-router';

import { env } from '../../../__config__/env';

interface IMenuState {
  modalVisible: boolean;
  searchVisible: boolean;
}

type ContextProps = {
  menuState: IMenuState;
  setMenuState: any;
};

export const MenuContext = React.createContext<ContextProps>({
  menuState: { modalVisible: false, searchVisible: false },
  setMenuState: null,
});

export const Header = (props: IMenuProps) => {
  const params = useParams<any>();

  const location = useLocation();
  const [menuItems, setMenuItems] = React.useState<Array<any>>([]);
  const [menuState, setMenuState] = React.useState<IMenuState>({
    modalVisible: false,
    searchVisible: false,
  });
  // const isSmall = typeof window !== 'undefined' && window.innerWidth < 600;

  const fadeIn: any = useSpring({
    position: 'fixed',
    transitionTimingFunction: 'ease-in-out',
    opacity: menuState.modalVisible ? 1 : 0,
    display: menuState.modalVisible ? 'block' : 'none',
  });

  const bgfadeIn: any = useSpring({
    position: 'absolute',
    top: '0',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    display:
      menuState.modalVisible || menuState.searchVisible ? 'block' : 'none',
    transitionTimingFunction: 'ease-in-out',
    opacity: menuState.modalVisible || menuState.searchVisible ? 1 : 0,
  });

  const shouldShowLogo = () => {
    return (
      props?.config?.logo !== false ||
      menuState.modalVisible ||
      menuState.searchVisible
    );
  };

  let className = '';
  if (props.className) {
    className = `${props.className}`;
  }
  if (menuState.modalVisible || menuState.searchVisible) {
    className += ' menu-open';
  }
  if (!props?.config?.transparent) {
    className += ' menu-background';
  } else {
    className += ' menu-no-background';
  }

  React.useEffect(() => {
    if (location.pathname === '/' || params?.p1 != 'kontor') {
      setMenuItems([
        {
          name: 'Kjøpe nybygg',
          link: 'https://privatmegleren.no/kjope-bolig?sd=NYBYGG',
          relative: false,
        },
        {
          name: 'Våre kontor',
          link: '/',
          relative: true,
        },
        {
          name: 'Finansiering',
          link: '/artikkel/ny-tjeneste',
          relative: true,
        },
      ]);
    } else {
      setMenuItems([
        {
          name: 'Tjenester',
          link: `/kontor/${params?.p2}/tjenester`,
          relative: true,
        },
        {
          name: 'Kjøpe nybygg',
          link: `/kontor/${params?.p2}/kjope`,
          relative: true,
        },
        {
          name: 'Kontakt oss',
          link: `/kontor/${params?.p2}/kontakt`,
          relative: true,
        },
        {
          name: 'Våre kunder',
          link: `/kontor/${params?.p2}/vaarekunder`,
          relative: true,
        },
        {
          name: 'Nyheter',
          link: `/kontor/${params?.p2}/nyheter`,
          relative: true,
        },
      ]);
    }
  }, [, location.pathname]);

  return (
    <MenuContext.Provider value={{ menuState, setMenuState }}>
      <MenuWrapper
        className={className}
        zIndex={menuState.modalVisible || menuState.searchVisible ? 200 : 100}
        transparent={props?.config?.transparent || false}
      >
        <animated.div style={bgfadeIn}>
          <Bg />
        </animated.div>
        {shouldShowLogo() && <Logo />}
        <FlexEnd>
          <DesktopMenuElements
            vistopp={props.config?.vistopp === false ? false : true}
            menuelements={menuItems}
            history={props.history}
          />
        </FlexEnd>
      </MenuWrapper>
      <ModalMenuAnimationHolder style={fadeIn}>
        <ModalMenu menuelements={menuItems} />
      </ModalMenuAnimationHolder>
    </MenuContext.Provider>
  );
};

const FlexEnd = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

const ModalMenuAnimationHolder = styled(animated.div)`
  position: fixed;
  top: 56px;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 200;
  line-height: 1.3;

  @media (min-width: 1140px) {
    left: auto;
  }
`;

const MenuWrapper = styled.div<{ transparent: boolean; zIndex: number }>`
  font-size: 18px;
  position: fixed;
  line-height: 1.3;
  left: 0;
  right: 0;
  top: 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  height: 66px;
  background-color: ${(props) =>
    props.transparent ? 'none' : props.theme.colors.body};
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.3);
  z-index: ${(props) => (props.zIndex ? props.zIndex : 100)};
  padding: 0 30px;
`;

const Bg = styled.div`
  background-color: rgba(0, 0, 0, 0.9);
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  position: absolute;
  z-index: -1;
`;
